// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--text-color);
  }
  
  .mobile-container::-webkit-scrollbar{display: none;}

  .mobile-card {
    margin-bottom: 1rem;
    position: relative;
    cursor: pointer;
  }
  
  .mobile-card img {
    width: 100%; /* Make the images stretch to fit the screen width */
    height: auto; /* Ensure the aspect ratio is maintained */
  }
  
  .mobile-card-details {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    color: white;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
  }
  
  .mobile-card.selected .mobile-card-details {
    opacity: 1;
    pointer-events: auto;
  }

  .mobile-container h2{
    text-align: center;
    color: var(--main-color);
    /* text-align: justify; */
    font-size: 1.21rem;
    margin: 2rem 0rem 0rem 0rem;
    text-shadow:  0 0px #fff, 0 0 3px #fff, 0 0 3px var(--text-color), 0 0 9px var(--main-color), 0 0 9px var(--main-color), 0 0 9px var(--main-color), 0 0 9px var(--main-color);
    
  }

  .mobile-card-details h1 {
    font-size: 1.2rem;
    font-weight: 700;
    margin-bottom: 2rem;
    text-shadow:  0 1px #fff, 0 0 2px #fff, 0 0 3px #e60073, 0 0 4px #e60073, 0 0 5px #e60073, 0 0 6px #e60073, 0 0 7px #e60073;
    text-align:center ;
  }
  
  .mobile-card-details .ico a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 2.5rem;
    height: 2.5rem;
    background: white;
    color: var(--main-color);
    box-shadow: 0 0 1rem white;
    border: 0.2rem solid white;
    border-radius: 50%;
    font-size: 2rem; 
    margin-top: -20px;
    margin-bottom: 0.5rem;
    transition: 0.5s ease;
  }

  .mobile-card-details .card {
    max-width: 90%;
    border-top: 1px solid white;
    padding-top: 1rem;
    margin-top: 1rem;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./src/components/Innovations/Inno-phn.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA,qCAAqC,aAAa,CAAC;;EAEnD;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW,EAAE,oDAAoD;IACjE,YAAY,EAAE,0CAA0C;EAC1D;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,kCAA0B;YAA1B,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,2BAA2B;IAC3B,6KAA6K;;EAE/K;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,2HAA2H;IAC3H,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,wBAAwB;IACxB,0BAA0B;IAC1B,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB","sourcesContent":[".mobile-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: var(--text-color);\n  }\n  \n  .mobile-container::-webkit-scrollbar{display: none;}\n\n  .mobile-card {\n    margin-bottom: 1rem;\n    position: relative;\n    cursor: pointer;\n  }\n  \n  .mobile-card img {\n    width: 100%; /* Make the images stretch to fit the screen width */\n    height: auto; /* Ensure the aspect ratio is maintained */\n  }\n  \n  .mobile-card-details {\n    position: absolute;\n    top: 0px;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.5);\n    backdrop-filter: blur(5px);\n    color: white;\n    opacity: 0;\n    transition: opacity 0.3s;\n    pointer-events: none;\n  }\n  \n  .mobile-card.selected .mobile-card-details {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .mobile-container h2{\n    text-align: center;\n    color: var(--main-color);\n    /* text-align: justify; */\n    font-size: 1.21rem;\n    margin: 2rem 0rem 0rem 0rem;\n    text-shadow:  0 0px #fff, 0 0 3px #fff, 0 0 3px var(--text-color), 0 0 9px var(--main-color), 0 0 9px var(--main-color), 0 0 9px var(--main-color), 0 0 9px var(--main-color);\n    \n  }\n\n  .mobile-card-details h1 {\n    font-size: 1.2rem;\n    font-weight: 700;\n    margin-bottom: 2rem;\n    text-shadow:  0 1px #fff, 0 0 2px #fff, 0 0 3px #e60073, 0 0 4px #e60073, 0 0 5px #e60073, 0 0 6px #e60073, 0 0 7px #e60073;\n    text-align:center ;\n  }\n  \n  .mobile-card-details .ico a {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 2.5rem;\n    height: 2.5rem;\n    background: white;\n    color: var(--main-color);\n    box-shadow: 0 0 1rem white;\n    border: 0.2rem solid white;\n    border-radius: 50%;\n    font-size: 2rem; \n    margin-top: -20px;\n    margin-bottom: 0.5rem;\n    transition: 0.5s ease;\n  }\n\n  .mobile-card-details .card {\n    max-width: 90%;\n    border-top: 1px solid white;\n    padding-top: 1rem;\n    margin-top: 1rem;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
